document.addEventListener("click", async (event) => {
  const btn = event.target.closest(".as-add-to-cart");
  if (!btn) return;

  const variantId = btn.dataset.variantId;
  if (!variantId) return;

  if (btn.classList.contains("is-loading")) return;

  btn.classList.add("is-loading");
  btn.disabled = true;

  try {
    await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 1,
      }),
    });

    document.dispatchEvent(new CustomEvent("cart:refresh"));
    document.dispatchEvent(new CustomEvent("cart:opened"));
  } catch (e) {
    console.error(e);
  } finally {
    btn.classList.remove("is-loading");
    btn.disabled = false;
  }
});
